export let data = {
  title: "Input Pemeriksaan Dokter",
  backBtn: "/ranap",
  actionBtn: [],
  breadcrumb: [
    { title: "Rawat Inap", link: "/ranap" },
    { title: "Detail Rawat Inap", link: "/ranap" },
    { title: "Input Pemeriksaan Dokter", active: true },
  ],
};
export let detailTop = {
  picture: "https://randomuser.me/api/portraits/men/97.jpg",
  topSubtitle: "",
  title: "Ahmad Subekti",
  subtitle: "No RM : 12345 | Pasien Peserta BPJS",
  items: [
    { icon: "wc", content: "Laki-laki" },
    { icon: "phone", content: "0897-2020-9090" },
  ],
  topRight: [
    {
      key: 1,
      columns: [
        {
          colnum: 5,
          icon: "today",
          label: "TANGGAL LAHIR",
          content: "20 Des 1990 (30 th)",
        },
        {
          colnum: 7,
          icon: "",
          label: "PENANGGUNG JAWAB",
          content: "Rina Gunawan (Ibu)",
        },
      ],
    },
    {
      key: 1,
      columns: [
        { colnum: 5, icon: "wb_sunny", label: "AGAMA", content: "Islam" },
        {
          colnum: 7,
          icon: "place",
          label: "",
          content:
            "Jl. Bangau 7 no. 180, RT 003/009 \nPerumnas Depok I Kel. Depok Jaya, \nKec. Pancoran Mas Depok, Jawa Barat",
        },
      ],
    },
  ],
};

export let detailLeftTop = [
  {
    key: String(Math.random(1023)),
    columns: [
      {
        label: "No. Rawat",
        content: "2020/04/16/000001",
        icon: "apps",
        colwidth: 6,
      },
      {
        label: "Unit",
        content: "MAT | Poliklinik Mata",
        icon: "apps",
        colwidth: 6,
      },
    ],
  },
];
export let detailRightTop = [
  {
    label: "Dokter yang Dituju",
    content: "D00000026  |   dr. Azizah Masthura",
    icon: "apps",
  },
];

export let today = new Date();
import { getTime } from "./helper.js";
export let time = getTime(today.getHours(), today.getMinutes());

export let leftForm = [
  {
    colnum: 2,
    columns: [
      {
        label: "Tanggal Periksa",
        type: "date",
        placeholder: "Pilih tanggal periksa",
        name: "tgl_periksa",
        value: today,
        mandatory: true,
        additional: "",
        colwidth: "6",
      },
      {
        label: "Jam",
        type: "time",
        placeholder: "jj:mm",
        name: "jam_periksa",
        value: time,
        mandatory: true,
        additional: "",
        colwidth: "4",
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Pemeriksaan Fisik",
        type: "image",
        placeholder: "",
        name: "fisik",
        mandatory: true,
        additional: "",
        rows: 8,
      },
    ],
  },
];
export let rightForm = [
  {
    colnum: 1,
    columns: [
      {
        label: "Dx Utama",
        type: "textarea",
        regex: /^.{0,255}$/,
        regexError: "Melebihi batas maksimal (255 karakter)",
        placeholder: "Masukkan diagnosis utama",
        name: "dx_utama",
        value: "",
        mandatory: true,
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Dx Sekunder",
        type: "textarea",
        regex: /^.{0,255}$/,
        regexError: "Melebihi batas maksimal (255 karakter)",
        placeholder: "Masukkan diagnosis sekunder",
        name: "dx_sekunder",
        value: "",
        mandatory: true,
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Penatalaksanaan Medis",
        type: "textarea",
        regex: /^.{0,255}$/,
        regexError: "Melebihi batas maksimal (255 karakter)",
        placeholder: "Masukkan penatalaksanaan medis",
        name: "medis",
        value: "",
        mandatory: true,
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "SOAP Dokter",
        type: "textarea",
        regex: /^.{0,255}$/,
        regexError: "Melebihi batas maksimal (255 karakter)",
        placeholder: "max. 255 karakter",
        name: "soap",
        value: "",
        mandatory: false,
        optional: true,
        additional: "",
      },
    ],
  },
];
